export const ENTITY_TYPE_REDIRECTION_MAP: Record<string, string> = {
  audit: '/audits',
  contract: '/contracts',
  notification: '/notifications',
  schedule: '/schedule',
  findings: '/findings',
  actions: '/actions',
  financials: '/financials',
  certificates: '/certificates',
  organization: '/settings',
  enabling: '/settings?tab=members',
};
